"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _slatePlugins = require("@udecode/slate-plugins");
var _slateReact = require("slate-react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("./styles");
var _LinkForm = _interopRequireDefault(require("./LinkForm"));
var _keycodes = require("../../../constants/keycodes");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var LinkToolBar = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var typeLink = _ref.typeLink;
  var editor = (0, _slateReact.useEditor)();
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    selection = _useState4[0],
    setSelection = _useState4[1];
  var toggleIsOpen = (0, _react.useCallback)(function () {
    setIsOpen(function (prevIsOpen) {
      if (!prevIsOpen) {
        setSelection(editor.selection);
      }
      return !prevIsOpen;
    });
  });
  var handleClick = function handleClick(event) {
    event.stopPropagation();
    event.preventDefault();
    toggleIsOpen();
  };
  var handleKeyDown = function handleKeyDown(event) {
    if (isOpen && event.keyCode === _keycodes.ESC) {
      toggleIsOpen();
    }
  };
  (0, _react.useEffect)(function () {
    document.addEventListener('keydown', handleKeyDown, false);
    return function () {
      document.removeEventListener('keydown', handleKeyDown, false);
    };
  }, []);
  var handleLink = (0, _react.useCallback)(function (_ref2) {
    var url = _ref2.url;
    editor.selection = selection;
    editor.upsertLinkAtSelection(editor, url, {
      typeLink: typeLink
    });
  }, [selection, editor]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_styles.StyledTextButton, {
    type: "button",
    onClick: handleClick
  }, "+ \u0421\u0441\u044B\u043B\u043A\u0430"), /*#__PURE__*/_react["default"].createElement(_styles.StyledPopup, {
    isOpen: isOpen
  }, isOpen && /*#__PURE__*/_react["default"].createElement(_LinkForm["default"], {
    onSubmit: handleLink,
    onClose: toggleIsOpen
  })));
});
LinkToolBar.propTypes = {
  typeLink: _propTypes["default"].string
};
LinkToolBar.defaultProps = {
  typeLink: _slatePlugins.ELEMENT_LINK
};
var _default = exports["default"] = LinkToolBar;